import ApiService from '../service/ApiService';
import MethodService from '../service/MethodService';

let moduleApi = {};
let moduleName = "phan_hoi";

moduleApi.create = (dataForm) => {
    let api = {
        module: moduleName,
        type: "create",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.update = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm
    };
    return ApiService(api);
};

moduleApi.updateSend = (dataForm) => {
    let api = {
        module: moduleName,
        type: "partialUpdate",
        value: dataForm,
        message: {
            success: 'hidden'
        }
    };
    return ApiService(api);
};

moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};

moduleApi.delete = (id) => {
    let api = {
        module: moduleName,
        type: "delete",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.findById = (id) => {
    let api = {
        module: moduleName,
        type: "findById",
        value: { id: id }
    };
    return ApiService(api);
};

moduleApi.countNew = (id) => {
    let filter = "trang_thai=new";
    if (MethodService.checkRole('TCQLTT')) {
        filter = 'tcqltt.trang_thai=new&tcqltt.nguoi_xu_ly_id=' + id;
    }
    let api = {
        module: moduleName,
        type: "list",
        value: {
            limit: 1,
            filters: filter
        },
        dontLoading: true
    };

    return ApiService(api);
};

moduleApi.suggestUser = (name) => {
    let api = {
        module: moduleName,
        type: "views",
        viewAction: "suggest_response_user",
        value: { name: name }
    };
    return ApiService(api);
};

export default moduleApi;